import React, { useState, useEffect } from "react";

import RegistrationTypeServices from "services/RegistrationTypeServices";
import useToggleDrawer from "hooks/useToggleDrawer";
import PageTitle from "components/Typography/PageTitle";
import MainDrawer from "components/drawer/MainDrawer";
import DataWrapper from "./DataWrapper";
import NotFound from "components/table/NotFound"; // Import NotFound component
import RegistrationTypeDrawer from "components/drawer/RegistrationTypeDrawer";
import { useContext } from "react";
import { SidebarContext } from "context/SidebarContext";
import { FiRefreshCcw } from "react-icons/fi";
import DeleteModal from "components/modal/DeleteModal";
import useAsync from "hooks/useAsync";
import {
  Card,
  CardBody,
  Input,
  Table,
  TableCell,
  TableContainer,
  TableHeader,
  Button,
} from "@windmill/react-ui";
import { FiPlus } from "react-icons/fi";
import sidebar from "routes/sidebar";

import ExportDataXlsx from "components/common/ExportDataXlsx";
import RegistrationTypeTable from "components/registrationType/registrationTypeTable";

const style = `.downloadbtn .svg-inline--fa {
  font-size: 30px; 
  color:grey;
  padding: 9px 10px;
  margin: unset;
}`;

const RegistrationType = () => {
  const adminInfo = localStorage.getItem("adminInfo")
    ? JSON.parse(localStorage.getItem("adminInfo"))
    : null;
  const { toggleDrawer, setIsUpdate } = useContext(SidebarContext);
  const [searchText, setSearchText] = useState("");
  const { data, loading, error } = useAsync(() =>
    RegistrationTypeServices.getAllRegistrationType(),
  );
  const isDataArray = Array.isArray(data?.data); // Check if data is an array
  const safeData = isDataArray ? data?.data : []; // Use empty array if data is not an array

  const [status, setStatus] = useState("");

  const isAdmin = adminInfo?.id === 1;

  const hideView = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "registration type" && perm.view === 1,
      );

  const hideDelete = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "registration type" && perm.delete === 1,
      );

  const hideEdit = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "registration type" && perm.edit === 1,
      );

  const hideAdd = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "registration type" && perm.add === 1,
      );

  const hideExport = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "registration type" && perm.export === 1,
      );
  useEffect(() => {
    if (data?.status) {
      setStatus(data.status);
    } else {
      setStatus(false);
    }
  }, [data?.status]);

  const { title, serviceId } = useToggleDrawer();

  // Contains the column headers and table data in the required format for CSV
  const csvData = [
    ["S.No", "Registration Type"],
    ...safeData?.map(({ name }, index) => [index + 1, name]),
  ];

  const filteredData = safeData.filter(
    (item) =>
      item.name !== null &&
      item.name.toLowerCase().includes(searchText.toLowerCase()),
  );

  const handleRefresh = () => {
    setIsUpdate(true);
  };
  return (
    <>
      {hideView && (
        <>
          <DeleteModal id={serviceId} title={title} />

          <style>{style}</style>
          <PageTitle sidebar={sidebar().sidebar} />

          <MainDrawer>
            <RegistrationTypeDrawer id={serviceId} />
          </MainDrawer>

          <Card className="min-w-0 shadow-xs overflow-hidden bg-white dark:bg-gray-800 mb-5">
            <CardBody>
              <form className="flex gap-6 items-center">
                <div className="flex-1">
                  <Input
                    className="border h-10 text-sm focus:outline-none block w-full bg-gray-100 border-transparent focus:bg-white"
                    type="search"
                    name="search"
                    autoComplete="off"
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                    placeholder="Quick Search"
                  />
                </div>

                {hideAdd && (
                  <Button
                    onClick={toggleDrawer}
                    className="w-56 rounded-md h-10"
                  >
                    <span className="mr-3">
                      <FiPlus />
                    </span>
                    Add Registration Type
                  </Button>
                )}

                {hideExport && (
                  <ExportDataXlsx
                    title="Registration Type List"
                    exportDataXlsx={csvData}
                    fileNames="Registration Type List"
                  />
                )}

                <FiRefreshCcw
                  onClick={() => {
                    handleRefresh();
                  }}
                  cursor="pointer"
                />
              </form>
            </CardBody>
          </Card>
          {/* <div className="data-table-container"> */}
          <DataWrapper loading={loading} error={error} status={status}>
            {filteredData.length > 0 ? (
              <TableContainer
                className="mb-8"
                style={{
                  maxHeight: "65vh",
                  overflowY: "scroll",
                  scrollbarWidth: "thin",
                }}
              >
                <Table>
                  <TableHeader className="custom-table-header capitalize sticky top-0 z-10 text-center">
                    <tr>
                      <TableCell>Sl.No.</TableCell>
                      <TableCell>Registration Type</TableCell>
                      {(hideEdit || hideDelete) && (
                        <TableCell>Actions</TableCell>
                      )}
                    </tr>
                  </TableHeader>

                  <RegistrationTypeTable
                    registrationTypedata={filteredData}
                    hideEdit={hideEdit}
                    hideDelete={hideDelete}
                  />
                </Table>
              </TableContainer>
            ) : (
              // Show NotFound if there is no data
              <NotFound title="There are no Registration Type." />
            )}
          </DataWrapper>
          {/* </div> */}
        </>
      )}
    </>
  );
};

export default RegistrationType;
